window.addEventListener("load", () => {
  var itemNumber = 0;
  var blockCommerceCart = document.querySelector(".block-commerce-cart");

  if (blockCommerceCart) {
    var cartSummaryCount = document.querySelector(
      ".cart-block--summary__count"
    );
    var cartBlockHeader = document.querySelector(
      ".cart-block .view-header .items"
    );
    var cartContentsItems = document.querySelectorAll(
      ".cart-block--contents__items .cart.cart-block"
    );
    var cartContentsLinks = document.querySelectorAll(
      ".cart-block--contents__links a"
    );

    if (cartSummaryCount && cartSummaryCount.textContent !== "0 items") {
      cartSummaryCount.textContent =
        cartSummaryCount.textContent.split(" ")[0];
      cartBlockHeader.textContent =
        cartSummaryCount.textContent.split(" ")[0] + " Item(s)";
      cartSummaryCount.style.display = "block";
      blockCommerceCart.style.display = "block";
    }

    cartContentsItems.forEach(function (cartItem) {
      if (cartItem.querySelectorAll(".views-row").length > 3) {
        itemNumber = 1;
      }
    });

    cartContentsLinks.forEach(function (cartLink) {
      cartLink.classList.add("button-red");
      cartLink.innerHTML = "<div>" + cartLink.textContent + "</div>";
    });

    if (itemNumber === 1) {
      document
        .querySelector(".cart-block--contents")
        .classList.add("cart-block-hide");

      document
        .querySelector(".cart--cart-block")
        .addEventListener("click", function (e) {
          window.location.replace("/cart");
        });
    }
  }
});